import React from 'react';
import styled from 'styled-components';
import { DefaultPalette, Slider, Stack, IStackStyles, IStackTokens } from '@fluentui/react';
import { ResponsiveBar } from '@nivo/bar'

const itemStyles = {
    alignItems: 'center',
    background: '#f2f2f2',
    height: '150px',
    width: '400px',
    justifyContent: 'center',
};

const stackStyles = {
    root: {
        width: `100%`
    },
};

const stackWrapperStyles = {
    backgroundColor: `#000000`,
    height: `100vh`
};

const Title = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
`;

const data = [
    {
        "key": "birthplace",
        "ในประเทศ": 100,
    }
];

const colors = { 
    'ในประเทศ': '#e0b672'}
const getColor = bar => colors[bar.id]

// Tokens definition
const sectionStackTokens = { childrenGap: 10 };
const wrapStackTokens = { childrenGap: 10 };


class BirthPlace extends React.Component {

    render() {
        return (
            <span style={itemStyles}>
                <Title>ภูมิลำเนาของผู้ตอบแบบสอบถาม</Title>
                <ResponsiveBar
                    data={data}
                    maxValue={100}
                    keys={['ในประเทศ']}
                    indexBy="birthplace"
                    margin={{ top: 10, right: 10, bottom: 80, left: 10 }}
                    padding={0.3}
                    layout="horizontal"
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    valueFormat={{ format: '', enabled: false }}
                    colors={getColor}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: '#38bcb2',
                            size: 1,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: '#eed312',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}
                    fill={[
                        {
                            match: {
                                id: 'ในประเทศ'
                            },
                            id: 'dots'
                        },
                    ]}
                    borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    axisTop={null}
                    axisRight={null}
                    axisLeft={null}
                    label={d => `${d.id} ${d.value}%, 457 คน`}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    // labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    labelTextColor="black"
                />
            </span>
        );
    }
}

export default BirthPlace;